module.exports = __webpack_public_path__ + "img/alarmTime.582faa14.png";